import React,{useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { wbDebounce, createOkrPeriodName } from '../../../../../utils/common';
import HamburgMenuComp from '../../../../../components/hamburgmenu';
import AvatarComp from '../../../../../components/helper/avatar';
import EditMetric from '../../../../../components/okr/wizard/editMetric.component';
import { WbEventHandlerMixins } from "../../../../../utils/common.js";
import { getExternalAppIconClass, getExternalAppIconDataUri } from '../../../../../utils/kpi-market-place-util';
import { getMitChildCounting, MIT_TYPE } from './mitConstants';

function HamComp(props){
    const { t } = useTranslation()
    const [showAd, setValue] = useState(false);
    const [hamburgStatus, disableHamburg] = useState(false);
    const handleShowAd = () => {
        setValue(true);
    }

    const handleCloseAd = () => {
        setValue(false);
    }

    const reRenderMenu = () => {
      disableHamburg(true);
        setTimeout(()=>{
          disableHamburg(false);
        }, 0)
    }

    const handleInclude = () => {
        props.setHide(false,props.mitIndex);
        reRenderMenu();
        menu.items = !props.disable ? [
            {
              title: t("Edit measurement type"),
              handler: handleShowAd ,
              spriteClass: 'icon icon-outline-edit-24px scaleDown1',
              //pic: "edit_img",
              item: props.subAiDet
            },
            {
              title: t("Exclude key result"),
              handler: handleExclude ,
              imageclass: "scaleDown2",
              pic: "hide_icon",
              item: props.subAiDet
            }
          ] : [{
            title: t("Exclude key result"),
            handler: handleExclude ,
            imageclass: "scaleDown2",
            pic: "hide_icon",
            item: props.subAiDet
          }];
    }
    const handleExclude = () => {
        if(props.dateSegment.targetValue == ""){
          props.handleChange({target:{name:"targetValue",value:"0"}}, props.mitIndex)
        }
        props.setHide(true,props.mitIndex)
        reRenderMenu();
        menu.items = [
            {
              title: t("Include key result"),
              handler: handleInclude ,
              imageclass: "scaleDown2",
              pic: "unHide_icon",
              item: props.subAiDet
            }
          ];
    }

    const menu = {};
    menu.items = (props.status == 3) ?
    [{
      title: t("Include key result"),
      handler: handleInclude,
      imageclass: "scaleDown2",
      pic: "unHide_icon",
      item: props.subAiDet
    }] : (props.disable) ? [{
      title: t("Exclude key result"),
      handler: handleExclude,
      imageclass: "scaleDown1",
      pic: "hide_icon",
      item: props.subAiDet
    }] :
    ((props.oneInclude && props.status == 1) ?
    [
      {
        title: t("Edit measurement type"),
        handler: handleShowAd,
        spriteClass: 'icon icon-outline-edit-24px scaleDown1',
        item: props.subAiDet
      }
    ] : [
      {
        title: t("Edit measurement type"),
        handler: handleShowAd,
        spriteClass: 'icon icon-outline-edit-24px scaleDown1',
        item: props.subAiDet
      },
      {
        title: t("Exclude key result"),
        handler: handleExclude,
        imageclass: "scaleDown1",
        pic: "hide_icon",
        item: props.subAiDet
      }
    ]);
    const item = {
        ...props.dateSegment
    };
    // console.log("this.props.realOwner 1", props.realOwner);
    let isStretchEnabled = props.addOkrData.isStretchEnabled ?? props.goalDetails.isStretchEnabled ?? false;
    let childItem = (props.child_krs[props.mitIndex] ? props.child_krs[props.mitIndex] : item);
    let targetVal = props.targetValue ?? childItem['target'] ?? '';
    let stretchVal = props.stretchValue ?? childItem['stretchTarget'] ?? '';
    let setStretch = (targetVal == '' && props.setStretch)  ? false : props.setStretch;
    if (props.child_krs[props.mitIndex]) {
      setStretch = childItem['setStretch'] !== undefined ? childItem['setStretch'] : (childItem['stretch_target'] !== '' && Number(childItem['committed_target'] == 0) ? true : false);
    }
    // disabling.  This is suppose to allow using the single target input for both target and stretch
    // but the logic is not populated everywhere and it is causing issues
    setStretch = false;
    if (childItem['quarterName'] && ((childItem['quarterName'] ==  "Custom time period" && props.mitType != MIT_TYPE.CUSTOM) || (childItem['quarterName'] !== props.dateSegment.quarterName))) {
      childItem['quarterName'] = props.dateSegment.quarterName == "Custom time period" ? props.keyMap :  props.dateSegment.quarterName;
    }
    childItem['target'] = (!isStretchEnabled || !setStretch) ? targetVal : '';
    childItem['stretch_target'] =   setStretch ? targetVal : stretchVal;
    // MR-8337: child direction follows parent; legacy Add-up + parent Decrease-to keeps Increase-to on children
    childItem['counting'] = getMitChildCounting(
      props.mitType,
      props.counting,
      childItem['counting'],
    );
    // OKR-9740: child inherits the parent's committed flag on save; mirror it in the disabled UI
    childItem['committed_target'] = childItem['committed_target'] ?? props.committedKRFlag;
    childItem['name'] = childItem['name'] ? childItem['name'] : props.intervalName;
    childItem['krId'] = childItem['id'] ? childItem['id'] : (childItem['krId'] ? childItem['krId'] : "");
    childItem['owner_pic'] = childItem['picture'] ? childItem['picture'] : (childItem['owner_pic'] ? childItem['owner_pic'] : props.ownerImg);
    childItem['real_owner_pic'] = childItem['real_owner_picture'] ? childItem['real_owner_picture'] : (childItem['real_owner_pic'] ? childItem['real_owner_pic'] : props.ownerImg);
    childItem['start_date'] = childItem['startDateText'] = (props.mitTypeChangeAlert ||  childItem['start_date'] == undefined) ? moment(props.dateSegment.startDate).format('MM/DD/YYYY') : childItem['start_date'];
    childItem['end_date'] =  childItem['endDateText'] = (props.mitTypeChangeAlert ||  childItem['end_date'] == undefined) ?  moment(props.dateSegment.endDate).format('MM/DD/YYYY') :  childItem['end_date'] ;
    childItem['real_owner'] = props.realOwner;
    childItem['coOwners'] = props.coOwners && props.coOwners.length > 0 ? props.coOwners : (childItem['coOwners'] != undefined && childItem['coOwners'].length ? childItem['coOwners'] : []);
    console.log('childItem', childItem);
    let isDiabledInitialField = false;
    if (childItem['owner'] == 'wb' && childItem['metricMirror']) {
      // if the metricMirror is missing, it likely means the source KR is deleted
      let metricMirrorInfo = childItem['metricMirror']['0'] || {
        picture: '',
        owner: '',
        owner_firstname: '',
        owner_fullname: '',
        owner_lastname: '',
        metricOwnerName: ''
      };

      childItem['owner_pic'] = childItem['picture'] = metricMirrorInfo['picture'];
      childItem['owner'] = metricMirrorInfo['owner'];
      childItem['owner_firstname'] = metricMirrorInfo['owner_firstname'];
      childItem['owner_fullname'] =  metricMirrorInfo['owner_fullname'];
      childItem['owner_lastname'] =  metricMirrorInfo['owner_lastname'];
      childItem['metricOwnerName'] = metricMirrorInfo['metricOwnerName'];
    }
    if (typeof props.mitType !== 'undefined'
      && props.mitType == MIT_TYPE.TRACK_PROGRESSION) {
        isDiabledInitialField = !moment().isAfter(childItem['start_date']);
        if (!isDiabledInitialField) {
          if (typeof childItem['initial_data'] === 'undefined' || childItem['initial_data'] == 0) {
            childItem['trackInitialData'] = props.parentInitialData;
          }
          if (typeof childItem['id'] !== 'undefined') {
            const previousObj = props.child_krs[props.mitIndex - 1] || {};
            if (childItem['initial_data'] == null || childItem['initial_data'] == '') {
              if (Object.keys(previousObj).length) {
                  if (previousObj.initial_data === null) {
                      childItem['trackInitialData'] =props.parentInitialData;
                  } else {
                      childItem['trackInitialData'] = previousObj.raw_achieve_target ||  previousObj.initial_data;
                  }
              } else {
                childItem['trackInitialData'] = props.parentInitialData;
              }
            } else {
              childItem['trackInitialData'] = childItem['initial_data'];
            }
          }
        }
    }
    let tempKrType = childItem.source ? WbEventHandlerMixins.getKrType(childItem.source, 1, childItem.ext_app_id) : '';
    const [krType, setKrType] = useState(tempKrType);

    useEffect(()=>{
        setKrType(tempKrType)
    }, [tempKrType]);

    return(
        <>
          <div style={{ width: "25px",marginLeft: "16px",paddingTop: "8px", position:"relative" }}>
           {!hamburgStatus && <HamburgMenuComp
                key={props.keyMap}
                menu={menu}
                style = {{marginLeft:-176}}
                disableHamburg={(props.disable && props.oneInclude && props.status == 1)}
            />}
          </div>
            <div
                className={"child-kr-id hidden"}
                data-child-kr-id={props.krId}
            />
         <div>
            {showAd ?
                 <EditMetric
                    {...props}
                    krType={krType}
                    mitChildKr={true}
                    closeKrRightPane={handleCloseAd}
                    isDiabledInitialField={isDiabledInitialField}
                    item={childItem}
                    parentKRID={props.item.id}
                    updateKRDataObject={()=>{
                        handleCloseAd();
                        let getKrType= krType;
                        setKrType("");
                        setTimeout(()=>{
                            handleShowAd();
                            setKrType(getKrType);
                        }, 0);
                    }}
                />
             : ''}
        </div>
        </>
    )


}

const QuarterlyIntervals = (props) => {
  const { t } = useTranslation()
    const quarterMap = {
        0: 'Q1',
        1: 'Q2',
        2: 'Q3',
        3: 'Q4'
    };
    let {
        mitIndex, year, intervalName, handleChange, handleStatus, targetValue, krId,ownerImg,ext_app_id,
        segmentError = {}, status, sourceId, qtype
    } = props;
    const qName = mitIndex % 4;
    year = parseInt(year);
    const inputIndex1 = `${mitIndex}3`;
    const inputIndex2 = `${mitIndex}4`;
    let quarterName = (props.quarterName && props.quarterName.split(' ').length > 2) ? createOkrPeriodName(quarterMap[qName], year, 1) : props.quarterName;

    const { nameError = false, targetError = false, targetResultDirectionError = false, targetResultDirectionMsg = '' } = segmentError;
    const getSourceIconClass = (extAppId, source_Id) =>
    {
      let iconClass = null;
      if (extAppId) {
        iconClass = getExternalAppIconClass(ext_app_id);
      }

      if (iconClass == null) {
        iconClass = (source_Id) ? `metricIcon_${(qtype == 2) ? 9 : source_Id}` : 'basickrIcon';
        if(source_Id == 3) {
          iconClass = `metricIcon_3 rollupMIT`;
        }
        if(source_Id == 7) {
          iconClass = `metricIcon_3 rollupMIT2`;
        }
      }
      return iconClass;
    }
    return (
    <div className={"mit-interval-targets"} data-testid="mit-interval-targets">
        <div className="w100" style={{display: 'flex'}}>
            <div style={
                    {margin: "0 2px 0 0", width: "85px"}
                }
                className={"verticalTop inLineBlk"}>
                <input type="text"
                        name="quarterName"
                        className={`metric-lower-value ${status==3 ? 'excludeMit' : ''} ` }
                        data-testid="metric-lower-value"
                        value={quarterName}
                        tabIndex={inputIndex2}
                        style={{width:'80%'}}
                        disabled/>
                <br/>
            </div>
            <div style={{flexGrow:1}}
                className={"verticalTop inLineBlk"}>
                <input type="text" name="intervalName"
                    className={`metric-lower-value ${status==3 ? 'excludeMit' : ''} ${nameError ? ' errorBorder ' : ''}`}
                    data-testid="metric-lower-value"
                    value={
                        intervalName
                    }
                    placeholder={"Target name"}
                    aria-label = {intervalName}
                    onChange={
                        e => wbDebounce(handleChange(e, mitIndex), 250)
                    }
                    autoComplete="off"
                    tabIndex={0}
                    style={{width:'87%', margin: '0px 15px 0 17px'}}
                    disabled = {status==3 || sourceId == 11}
                    />

                <br/>
                {
                    nameError &&
                    <div className = {`krNameError`} style={{marginLeft: 15}}>
                        <i className={"icon icon-outline-error_outline-14px-red"}></i> &nbsp;{t('Add interval name')}
                    </div>
                }
            </div>
            <div style={
                    {margin: "0 2px 0 8px"}
                }
                className={"verticalTop inLineBlk"}>
                <input type="text" name="targetValue"
                    className={`metric-lower-value ${status==3 ? 'excludeMit' : ''} ${(targetError || targetResultDirectionError) ? ' errorBorder ' : ''}` }
                    data-testid="metric-lower-value"
                    value={sourceId == 2 && targetValue === '' ? '--' : targetValue}
                    onChange={
                        e => handleChange(e, mitIndex)
                    }
                    aria-label = {sourceId == 2 && targetValue === '' ? '--' : targetValue}
                    autoComplete="off"
                    tabIndex={0}
                    style={{width: 80}}
                    disabled = {status==3 || sourceId == 11 || sourceId == 2}
                />
                <br/>
                {
                    targetError &&
                    <div
                        className = {
                            `krNameError`
                        }
                        data-testid="krNameError" >
                        <i className={"icon icon-outline-error_outline-14px-red"}></i> &nbsp;{t('Add value')}
                    </div>
                }
            </div>
            {status==3 ?
            <div
            className={`quarterAvatar hide_icon`}
            style={{marginRight: '0px'}}>
            </div>  :
             ( (sourceId == 1) ?
                  <div className='quarterAvatar' >
                      <AvatarComp src={ownerImg} imageClass="fitProfileImage" useSpriteSheet={props.useSpriteSheet}/>
                  </div>: (
                    getSourceIconClass(ext_app_id, sourceId) ?
                    <div
                        className={`quarterAvatar ${getSourceIconClass(ext_app_id, sourceId)}`}
                        style={{marginRight: '0px'}}>
                    </div> :
                    <div className={`quarterAvatar`}><img src={getExternalAppIconDataUri(ext_app_id)}/></div>
                  ))
            }
           <HamComp setHide = {handleStatus}  keyMap = {quarterMap[qName]} krId = {krId} {...props}>
            </HamComp>
        </div>
        {
          targetResultDirectionError &&
          <div
              className = {
                  `krNameError`
              }
              data-testid="krNameError" >
              <i className={"icon icon-outline-error_outline-14px-red"}></i> &nbsp;{targetResultDirectionMsg}
          </div>
        }
        <div className={"clear"}/>
    </div>
);
}

export default QuarterlyIntervals;